import { ClientTranslatableErrorResponse } from '../types/errors';

export function isClientTranslatableException(
  error: any
): error is ClientTranslatableErrorResponse {
  return (
    !!error &&
    typeof error === 'object' &&
    !!error?.['key'] &&
    typeof error['key'] === 'string' &&
    !!error?.['params']
  );
}
